import { render, staticRenderFns } from "./SystemConfigPage.vue?vue&type=template&id=6729b2b2&scoped=true"
import script from "./SystemConfigPage.vue?vue&type=script&lang=js"
export * from "./SystemConfigPage.vue?vue&type=script&lang=js"
import style0 from "./SystemConfigPage.vue?vue&type=style&index=0&id=6729b2b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6729b2b2",
  null
  
)

export default component.exports